import { featureFlagClient, useFeatureFlag } from '@trello/feature-flag-client';
import { memberId } from '@trello/session-cookie';
import { idToDate } from '@trello/dates';

const CUTOFF_DATE = new Date('2019-12-18');
const PHASE_1_FLAGNAME = 'btg.all-users-are-admins.phase-1';
const PHASE_2_FLAGNAME = 'btg.all-users-are-admins.phase-2';

const auaaCheckEnabled = (
  flagGetter: (flagName: string, defaultValue: boolean) => boolean,
  cutoffDate?: Date,
) => {
  const phase1FlagEnabled = flagGetter(PHASE_1_FLAGNAME, false);
  const newUser = idToDate(memberId!) >= (cutoffDate || CUTOFF_DATE);
  const phase1Enabled = phase1FlagEnabled && newUser;

  const phase2Enabled = flagGetter(PHASE_2_FLAGNAME, false);

  return phase2Enabled || phase1Enabled;
};

export const useAllUsersAreAdminsEnabled = (cutoffDate?: Date) =>
  auaaCheckEnabled(useFeatureFlag, cutoffDate);

export const allUsersAreAdminsEnabled = (cutoffDate?: Date) =>
  auaaCheckEnabled(featureFlagClient.get, cutoffDate);
